import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import style from './style.scss'; //NOSONAR

let map = null;
let actions = [];
const CustomAutocomplete = (props) => {

    const [search, setSearch] = useState('');
    const [autocomplete, setAutocomplete] = useState([]);
    const [searchSuggestion, setSearchSuggestion] = useState(null);
    const [isEmpty, setIsEmpty] = useState(false);
    const [position, setPosition] = useState(-1);
    const [sessionToken, setSessionToken] = useState('');
    const [streetInvalid, setStreetInvalid] = useState('');
    let isReference = false;
    let searchTime = '';
    let wrapperRef = useRef('');

    useEffect(() => {
        setSearch(props && props.value ? props.value : '');
        actions.push(PubSub.register('autocomoplete_clean', cleanSearch));

        document.addEventListener('mousedown', handleClickOutside);

        initMap({
            value: {
                map: document.createElement('div')
            }
        });

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];

        }
    }, []);

    useEffect(() => {
        document.addEventListener('keydown', _keyDown);

        return function cleanup() {
            document.removeEventListener('keydown', _keyDown);
        }
    }, [position, search, autocomplete]);

    const initMap = (payload) => {
        map = payload.value.map;
    }

    const handleClickOutside = (event) => {
        if (autocomplete.length > 0 && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setAutocomplete([]);
        }
    }

    const cleanSearch = () => {
        setSearch('');
        setAutocomplete([]);
    }

    const onChange = (search) => {
        setSearch(search);
        if (isEmpty) {
            PubSub.dispatch('address_autocomplete_is_empty', {
                isEmpty: false
            });
            setIsEmpty(false);
        }

        if (props.onChange) {
            props.onChange();
        }

        clearTimeout(searchTime);
        searchTime = setTimeout(() => {
            if (search.length > 3) {
                getInfo(search);
            }
        }, 300);
    }

    const onSelected = (selected) => {
        document.removeEventListener('keydown', _keyDown);
        setSearch(selected.structured_formatting.main_text);
        isReference = (selected.types.indexOf('geocode') === -1);

        if (props.onSelected && sessionToken) {
            let placeId = selected.place_id;
            const detailService = new google.maps.places.PlacesService(map);
            detailService.getDetails({
                placeId: placeId,
                sessionToken: sessionToken,
                fields: ['address_component', 'formatted_address', 'geometry', 'permanently_closed', 'place_id', 'type', 'name']
            }, (response) => {
                if (!response) {
                    const listAutocomplete = [];
                    setIsEmpty(true);

                    PubSub.dispatch('address_autocomplete_is_empty', {
                        isEmpty: isEmpty
                    });

                    setAutocomplete(listAutocomplete);
                    return false;
                }

                props.onSelected(response, isReference);
                setAutocomplete([]);

            });
        }

        setPosition(0);
    }

    const getInfo = (search) => {
        if(!google) return false;
        const autocompleteService = new google.maps.places.AutocompleteService(search);
        const types = [];

        if(!sessionToken) return false;

        autocompleteService.getPlacePredictions({
            input: search,
            sessionToken: sessionToken,
            bounds: props.bounds,
            componentRestrictions: { country: 'cl' },
            types
        }, (response) => {
            let autocomplete = response || [];

            let isEmpty = autocomplete.length === 0;

            PubSub.dispatch('address_autocomplete_is_empty', {
                isEmpty: isEmpty
            });

            setAutocomplete(autocomplete);

        });
    }

    const onBlurStreet = (event) => {
        const value = event;

        setTimeout(() => {
            if (streetInvalid) {
                setStreetInvalid(value.length && !this.place);
            }
        }, 350);
    }

    const openList = () => {
        if (autocomplete.length === 0) return false;
        setAutocomplete(autocomplete);
    }

    const getToken = () => {
        document.addEventListener('keydown', _keyDown);
        if(!google) return false;
        setSessionToken(new google.maps.places.AutocompleteSessionToken());
    }

    const _keyDown = (data) => {
        let arrayLength = autocomplete.length;

        if(search.length > 0){
            var pos;

            switch (data.keyCode) {
                case 40:
                    data.preventDefault();
                    pos = position + 1;
                    if(pos > arrayLength) {
                        pos = 0;
                    }
                    setPosition(pos);
                    setSearchSuggestion(autocomplete[pos].description);
                    break;
                case 38:
                    data.preventDefault();
                    pos = position - 1;
                    if(pos < -1) break;
                    setPosition(pos);
                    setSearchSuggestion(autocomplete[pos].description);
                    break;
                case 13:
                    data.preventDefault();
                    onSelected(autocomplete[position]);
                    setSearchSuggestion(null);
                    break;
            }
        }
    };

    const placeholder = props && props.placeholder || 'Select...';
    return (
        <div ref={wrapperRef} className={'pac-cont'}>
            {(searchSuggestion && search.length > 0) && <div className={'pac-search-suggestion'}><span className={'pac-search-suggestion-autocomplete'}>{search}</span>{(searchSuggestion.toLowerCase().indexOf(search.toLowerCase()) !== -1) && <span className={'pac-search-suggestion-autocomplete'}>{searchSuggestion.toLowerCase().split(search.toLowerCase())[1]}</span>}</div>}
            <input value={search} placeholder={placeholder} onChange={(event) => onChange(event.target.value)} onBlur={(event) => onBlurStreet(event.target.value)} onFocus={() => getToken()} onClick={() => openList()} />
            <div className={'pac-container'}>
                {autocomplete && autocomplete.map((aut, i) =>
                    <div className={'pac-item-wrap'+((i === position) ? ' hover': '')} key={aut.id} onClick={() => onSelected(aut)}>
                        <div className={'pac-item'}>
                            <i className={'pac-icon pac-icon-marker'} />
                            <span className={'pac-item-query'}>
                                {aut.description}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

}

CustomAutocomplete.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    options: PropTypes.array,
    disabled: PropTypes.bool,
    bounds: PropTypes.object,
    neighborhood: PropTypes.string,
    location: PropTypes.object,
    onSelected: PropTypes.func
};

export default CustomAutocomplete;
